import axios from 'axios'
axios.defaults.headers['Accept'] = 'application/json'
axios.defaults.headers['Content-Type'] = 'application/json'
import { JSSDKApi } from '@/api/jssdk'


//要用到微信API								
function getJSSDK() {
    axios.post(JSSDKApi,{url:location.href}).then(res => {
        window.wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端ale rt出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.appId, // 必填，公众号的唯一标识
            timestamp: res.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.nonceStr, // 必填，生成签名的随机串
            signature: res.signature, // 必填，签名
            jsApiList:[
                'updateAppMessageShareData', 
                'updateTimelineShareData',
                'chooseWXPay'
            ] // 必填，需要使用的JS接口列表
        })
        window.wx.error(function (res) {
            console.log(res);
            alert("微信验证失败");
        });
    })
}

//分享
function overrideWXShare(dataForWeixin, imgUrl='https://public.qiniu.xcims.com/logo.png') {
    imgUrl = imgUrl.replace('http://','https://')
    window.wx.ready(function () {
        let option = {
            title: dataForWeixin.title,
            desc: dataForWeixin.des,
            link: `https://web.xcims.com/api/wx/redirect/?url=${encodeURIComponent(dataForWeixin.linkurl)}`,
            imgUrl: imgUrl, // 必须是https前缀
            success: function success(res) {
                console.log('已分享');
                console.log(res);
            },
            cancel: function cancel(res) {
                console.log('已取消');
                console.log(res);
            },
            fail: function fail(res) {
                alert(JSON.stringify(res));
            }
        }
        console.log('分享的内容')
        console.log(option)
        //分享给微信朋友
        window.wx.updateAppMessageShareData(option);
        // 2.2 监听“分享到朋友圈”按钮点击、自定义分享内容及分享结果接口
        window.wx.updateTimelineShareData(option);
    })


}

function shareItem(title, des, imgUrl, descUrl) {
    console.log('onShare')
    let obj={
        title:`${title}`,
        des:`${ des }`,
        linkurl: `${ descUrl }`,//分享链接
    }
    getJSSDK()
    if (imgUrl) {
        overrideWXShare(obj, imgUrl)
    } else {
        overrideWXShare(obj)
    }
}

export default {
    // 获取JSSDK
    getJSSDK,
    overrideWXShare,
    shareItem
}